import axiosInstance from '../axiosInterceptor/axiosInstance'

const removeCard = ({ orgId }) => {
  const url = `v1/orgs/${orgId}/billing/card`
  return axiosInstance.delete(url)
}

export default removeCard
